// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Be+Vietnam+Pro:wght@300;500;700&family=Geist+Mono:wght@400;500&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.graph-page {
    --hmi-bg: #F5F8FC;
    --hmi-card: #FFFFFF;
    --hmi-accent: #006AFF;
    --hmi-accent-ink: #FFFFFF;
    --hmi-text: #0F1926;
    --hmi-muted: #596980;
    --hmi-hover: #E8F1FF;
    --hmi-border: #8F9EB3;
    --hmi-shadow: 0 1px 2px rgba(15, 23, 42, 0.04), 0 10px 28px rgba(15, 23, 42, 0.05);
    --hmi-row: #F8FAFC;
    --hmi-good: #047857;
    --hmi-good-bg: #ECFDF5;
    --hmi-warn: #B45309;
    --hmi-warn-bg: #FFFBEB;
    --hmi-danger: #B91C1C;
    --hmi-danger-bg: #FEF2F2;
    --hmi-input: #FFFFFF;
    color-scheme: light;
    box-sizing: border-box;
    min-height: calc(100vh - 64px);
    padding: 28px 32px 40px;
    background: var(--hmi-bg);
    color: var(--hmi-text);
    font-family: "Be Vietnam Pro", Arial, sans-serif;
    font-weight: 300;
}

.graph-page[data-theme="dark"] {
    --hmi-bg: #0F1926;
    --hmi-card: #162433;
    --hmi-accent: #006AFF;
    --hmi-accent-ink: #FFFFFF;
    --hmi-text: #FFFFFF;
    --hmi-muted: #8F9EB3;
    --hmi-hover: #1C2C42;
    --hmi-border: #596980;
    --hmi-shadow: 0 1px 2px rgba(0, 0, 0, 0.28), 0 12px 32px rgba(0, 0, 0, 0.22);
    --hmi-row: #121A2B;
    --hmi-good: #34D399;
    --hmi-good-bg: rgba(52, 211, 153, 0.12);
    --hmi-warn: #FBBF24;
    --hmi-warn-bg: rgba(251, 191, 36, 0.12);
    --hmi-danger: #FCA5A5;
    --hmi-danger-bg: rgba(248, 113, 113, 0.12);
    --hmi-input: #0F172A;
    color-scheme: dark;
}

.graph-page *,
.graph-page *::before,
.graph-page *::after {
    box-sizing: border-box;
}

.graph-page h1,
.graph-page h2,
.graph-page p {
    margin: 0;
    color: var(--hmi-text);
}

.graph-page__top {
    margin-bottom: 22px;
}

.graph-page__eyebrow {
    margin-bottom: 6px;
    color: var(--hmi-accent);
    font-size: 12px;
    font-weight: 700;
    letter-spacing: 0.08em;
    text-transform: uppercase;
}

.graph-page h1 {
    font-size: 32px;
    line-height: 1.15;
    font-weight: 700;
    letter-spacing: -0.03em;
}

.graph-page__subtitle {
    margin-top: 6px;
    color: var(--hmi-muted);
    font-size: 15px;
}

.graph-page__card {
    margin-bottom: 18px;
    border: 1px solid var(--hmi-border);
    border-radius: 18px;
    background: var(--hmi-card);
    box-shadow: var(--hmi-shadow);
    overflow: hidden;
}

.graph-page__card-head {
    padding: 18px 18px 0;
}

.graph-page__card-head h2 {
    font-size: 18px;
    letter-spacing: -0.02em;
}

.graph-page__card-head p,
.graph-page__empty {
    margin-top: 4px;
    color: var(--hmi-muted);
    font-size: 13px;
}

.graph-page__tabs,
.graph-page__ranges,
.graph-page__range-grid,
.graph-page__live-grid,
.graph-page__selectors,
.graph-page__actions,
.graph-page__banner,
.graph-page__empty,
.graph-page__plot,
.graph-page__live-note {
    margin: 16px 18px;
}

.graph-page__tabs,
.graph-page__ranges {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
}

.graph-page__tab {
    min-height: 40px;
    margin: 0;
    padding: 8px 16px;
    border: 1px solid var(--hmi-border);
    border-radius: 12px 12px 0 0;
    background: var(--hmi-card);
    color: var(--hmi-text);
    font: inherit;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
}

.graph-page__tab[aria-selected="true"] {
    border-color: var(--hmi-accent);
    background: var(--hmi-hover);
    color: var(--hmi-accent);
}

.graph-page__chip,
.graph-page__button {
    min-height: 40px;
    margin: 0;
    padding: 8px 14px;
    border: 1px solid var(--hmi-border);
    border-radius: 999px;
    background: var(--hmi-row);
    color: var(--hmi-text);
    font: inherit;
    font-size: 13px;
    font-weight: 700;
    cursor: pointer;
}

.graph-page__chip.is-active,
.graph-page__chip:hover,
.graph-page__chip:focus-visible {
    border-color: var(--hmi-accent);
    background: var(--hmi-hover);
    color: var(--hmi-accent);
}

.graph-page__range-grid,
.graph-page__live-grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 280px));
    gap: 14px;
}

.graph-page__appearance,
.graph-page__selectors {
    display: grid;
    gap: 12px;
}

.graph-page__appearance {
    grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
    align-items: end;
    margin: 0 18px 18px;
}

.graph-page__selector {
    display: flex;
    flex-wrap: wrap;
    align-items: flex-end;
    gap: 12px;
    padding: 12px;
    border: 1px solid var(--hmi-border);
    border-radius: 14px;
    background: var(--hmi-row);
}

.graph-page__field--color {
    flex: 0 0 88px;
}

.graph-page__field--axis {
    flex: 0 1 150px;
}

.graph-page__field input[type="color"] {
    padding: 4px;
}

.graph-page__field input[type="range"] {
    padding: 0;
    accent-color: var(--hmi-accent);
}

.graph-page__check {
    display: flex;
    align-items: center;
    gap: 8px;
    min-height: 40px;
    color: var(--hmi-text);
    font-size: 14px;
    font-weight: 700;
}

.graph-page__check input {
    width: 18px;
    height: 18px;
    margin: 0;
    accent-color: var(--hmi-accent);
}

.graph-page__field {
    display: flex;
    flex: 1 1;
    flex-direction: column;
    gap: 6px;
    min-width: 0;
}

.graph-page__field label {
    color: var(--hmi-muted);
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 0.05em;
    text-transform: uppercase;
}

.graph-page__field input,
.graph-page__field select {
    width: 100%;
    max-width: none;
    height: 40px;
    margin: 0;
    padding: 0 12px;
    border: 1px solid var(--hmi-border);
    border-radius: 10px;
    background: var(--hmi-input);
    color: var(--hmi-text);
    font: inherit;
    font-size: 14px;
}

.graph-page__field input:focus-visible,
.graph-page__field select:focus-visible,
.graph-page__chip:focus-visible,
.graph-page__button:focus-visible {
    outline: 2px solid var(--hmi-accent);
    outline-offset: 2px;
}

.graph-page__actions {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    padding-bottom: 18px;
}

.graph-page__button {
    border-radius: 12px;
    border-color: var(--hmi-accent);
    background: var(--hmi-card);
    color: var(--hmi-accent);
    box-shadow: var(--hmi-shadow);
}

.graph-page__button--primary {
    background: var(--hmi-accent);
    color: var(--hmi-accent-ink);
}

.graph-page__button--export {
    border-color: transparent;
    background: var(--hmi-good);
    color: #FFFFFF;
}

.graph-page[data-theme="dark"] .graph-page__button--export {
    color: #052E1C;
}

.graph-page__button--danger {
    border-color: transparent;
    background: var(--hmi-danger-bg);
    color: var(--hmi-danger);
    box-shadow: none;
}

.graph-page__button:hover,
.graph-page__button:focus-visible {
    filter: brightness(0.97);
}

.graph-page__preset-bar {
    display: flex;
    flex-wrap: wrap;
    align-items: flex-end;
    gap: 10px;
    margin: 16px 18px 0;
}

.graph-page__preset-bar .graph-page__field {
    flex: 1 1 240px;
}

.graph-page__preset-list {
    display: grid;
    gap: 12px;
    margin: 14px 0 0;
    padding: 0;
    list-style: none;
}

.graph-page__preset-item {
    padding: 12px;
    border: 1px solid var(--hmi-border);
    border-radius: 14px;
    background: var(--hmi-row);
}

.graph-page__preset-rename {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    align-items: center;
}

.graph-page__preset-rename input {
    flex: 1 1 180px;
    height: 40px;
    min-width: 0;
    padding: 0 12px;
    border: 1px solid var(--hmi-border);
    border-radius: 10px;
    background: var(--hmi-input);
    color: var(--hmi-text);
    font: inherit;
}

.graph-page__preset-tags {
    margin: 10px 0 0;
    padding-left: 18px;
    color: var(--hmi-muted);
    font-size: 13px;
}

.graph-page__dialog-backdrop {
    position: fixed;
    inset: 0;
    z-index: 30;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 24px;
    background: rgba(15, 25, 38, 0.45);
}

.graph-page__dialog {
    width: min(480px, 100%);
    max-height: min(80vh, 720px);
    overflow: auto;
    padding: 18px;
    border: 1px solid var(--hmi-border);
    border-radius: 18px;
    background: var(--hmi-card);
    box-shadow: var(--hmi-shadow);
}

.graph-page__dialog--wide {
    width: min(680px, 100%);
}

.graph-page__dialog h3 {
    margin: 0 0 8px;
    font-size: 18px;
}

.graph-page__dialog p {
    color: var(--hmi-muted);
}

.graph-page__banner.is-good {
    border-color: transparent;
    background: var(--hmi-good-bg);
    color: var(--hmi-good);
}

.graph-page__button:disabled {
    opacity: 0.55;
    cursor: not-allowed;
}

.graph-page__banner {
    padding: 12px 14px;
    border-radius: 12px;
    font-size: 14px;
    font-weight: 600;
}

.graph-page__banner.is-error {
    color: var(--hmi-danger);
    background: var(--hmi-danger-bg);
}

.graph-page__banner.is-warn {
    color: var(--hmi-warn);
    background: var(--hmi-warn-bg);
}

.graph-page__status {
    display: inline-flex;
    align-items: center;
    align-self: flex-start;
    min-height: 28px;
    margin-top: 2px;
    padding: 4px 10px;
    border-radius: 999px;
    background: var(--hmi-row);
    color: var(--hmi-muted);
    font-size: 12px;
    font-weight: 700;
    letter-spacing: 0.04em;
}

.graph-page__status.is-live {
    background: var(--hmi-good-bg);
    color: var(--hmi-good);
}

.graph-page__status.is-paused {
    background: var(--hmi-warn-bg);
    color: var(--hmi-warn);
}

.graph-page__status.is-loading {
    background: var(--hmi-hover);
    color: var(--hmi-accent);
}

.graph-page__status.is-error {
    background: var(--hmi-danger-bg);
    color: var(--hmi-danger);
}

.graph-page__live-note {
    color: var(--hmi-muted);
    font-size: 13px;
    line-height: 1.45;
}

.graph-page__live-note + .graph-page__live-note,
.graph-page__live-note + .graph-page__banner,
.graph-page__banner + .graph-page__banner {
    margin-top: 0;
}

.graph-page__empty {
    padding-bottom: 18px;
    text-align: center;
    font-size: 14px;
}

.graph-page__plot {
    height: min(520px, 62vh);
    min-height: 320px;
    padding: 8px 8px 0;
    overscroll-behavior: contain;
}

.graph-page__plot canvas {
    max-width: 100%;
}

.graph-page__table-wrap {
    max-height: 360px;
    margin-top: 8px;
    overflow: auto;
    border-top: 1px solid var(--hmi-border);
}

.graph-page__table {
    width: 100%;
    min-width: 480px;
    border-collapse: collapse;
}

.graph-page__table th,
.graph-page__table td {
    padding: 12px 16px;
    border-bottom: 1px solid var(--hmi-border);
    color: var(--hmi-text);
    text-align: left;
    font-size: 14px;
}

.graph-page__table th {
    position: sticky;
    top: 0;
    background: var(--hmi-row);
    color: var(--hmi-muted);
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 0.05em;
    text-transform: uppercase;
}

.graph-page__table tbody tr {
    cursor: pointer;
}

.graph-page__table tbody tr:hover td,
.graph-page__table tbody tr.is-selected td {
    background: var(--hmi-hover);
}

.graph-page__table tbody tr.is-selected td {
    color: var(--hmi-accent);
}

.graph-page__table tbody tr:focus-visible td {
    outline: 2px solid var(--hmi-accent);
    outline-offset: -2px;
}

.graph-page__card-head--split {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 12px;
}

.graph-page__swatch {
    width: 14px;
    height: 14px;
    margin-top: 6px;
    border-radius: 999px;
    flex: 0 0 auto;
}

.graph-page__zoom {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 8px;
    padding: 12px 18px 0;
}

.graph-page__zoom-state {
    color: var(--hmi-warn);
    font-size: 13px;
    font-weight: 700;
}

.graph-page__hint,
.graph-page__selection {
    margin: 8px 18px 0;
    color: var(--hmi-muted);
    font-size: 13px;
    line-height: 1.45;
}

.graph-page__selection {
    color: var(--hmi-text);
    font-size: 14px;
    font-weight: 650;
}

.graph-page__records-bar {
    display: flex;
    justify-content: flex-end;
    margin: 4px 0 12px;
}

.graph-page__records-body {
    max-height: min(520px, 58vh);
    overflow: auto;
}

.graph-page__record-group h3,
.graph-page__record-title {
    margin: 0;
    padding: 14px 16px 0;
    color: var(--hmi-text);
    font-size: 15px;
}

.graph-page__record-title {
    display: flex;
    align-items: center;
    gap: 8px;
}

.graph-page__record-title .graph-page__swatch {
    margin-top: 0;
}

.graph-page__record-group + .graph-page__record-group {
    border-top: 1px solid var(--hmi-border);
}

.graph-page__mono {
    font-family: "Geist Mono", ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;
    font-size: 13px;
    font-variant-numeric: tabular-nums;
}

.graph-page__value {
    font-weight: 700;
    font-variant-numeric: tabular-nums;
}

@media (max-width: 800px) {
    .graph-page {
        padding: 18px 14px 28px;
    }

    .graph-page h1 {
        font-size: 26px;
    }

    .graph-page__range-grid,
    .graph-page__live-grid,
    .graph-page__selector,
    .graph-page__actions {
        grid-template-columns: 1fr;
        flex-direction: column;
        align-items: stretch;
    }

    .graph-page__button,
    .graph-page__chip {
        width: 100%;
    }

    .graph-page__plot {
        height: 300px;
        min-height: 240px;
    }

    .graph-page__field--color,
    .graph-page__field--axis {
        flex: 1 1 auto;
    }

    .graph-page__zoom .graph-page__button,
    .graph-page__records-bar .graph-page__button {
        width: auto;
    }
}

@media (prefers-reduced-motion: reduce) {
    .graph-page__button,
    .graph-page__chip {
        transition: none;
    }
}
`, "",{"version":3,"sources":["webpack://./src/pages/GraphPage.css"],"names":[],"mappings":"AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,qBAAqB;IACrB,yBAAyB;IACzB,mBAAmB;IACnB,oBAAoB;IACpB,oBAAoB;IACpB,qBAAqB;IACrB,kFAAkF;IAClF,kBAAkB;IAClB,mBAAmB;IACnB,sBAAsB;IACtB,mBAAmB;IACnB,sBAAsB;IACtB,qBAAqB;IACrB,wBAAwB;IACxB,oBAAoB;IACpB,mBAAmB;IACnB,sBAAsB;IACtB,8BAA8B;IAC9B,uBAAuB;IACvB,yBAAyB;IACzB,sBAAsB;IACtB,gDAAgD;IAChD,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,qBAAqB;IACrB,yBAAyB;IACzB,mBAAmB;IACnB,oBAAoB;IACpB,oBAAoB;IACpB,qBAAqB;IACrB,4EAA4E;IAC5E,kBAAkB;IAClB,mBAAmB;IACnB,uCAAuC;IACvC,mBAAmB;IACnB,uCAAuC;IACvC,qBAAqB;IACrB,0CAA0C;IAC1C,oBAAoB;IACpB,kBAAkB;AACtB;;AAEA;;;IAGI,sBAAsB;AAC1B;;AAEA;;;IAGI,SAAS;IACT,sBAAsB;AAC1B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,wBAAwB;IACxB,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,eAAe;IACf,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,mCAAmC;IACnC,mBAAmB;IACnB,2BAA2B;IAC3B,6BAA6B;IAC7B,gBAAgB;AACpB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,eAAe;IACf,uBAAuB;AAC3B;;AAEA;;IAEI,eAAe;IACf,uBAAuB;IACvB,eAAe;AACnB;;AAEA;;;;;;;;;;IAUI,iBAAiB;AACrB;;AAEA;;IAEI,aAAa;IACb,eAAe;IACf,QAAQ;AACZ;;AAEA;IACI,gBAAgB;IAChB,SAAS;IACT,iBAAiB;IACjB,mCAAmC;IACnC,4BAA4B;IAC5B,2BAA2B;IAC3B,sBAAsB;IACtB,aAAa;IACb,eAAe;IACf,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,+BAA+B;IAC/B,4BAA4B;IAC5B,wBAAwB;AAC5B;;AAEA;;IAEI,gBAAgB;IAChB,SAAS;IACT,iBAAiB;IACjB,mCAAmC;IACnC,oBAAoB;IACpB,0BAA0B;IAC1B,sBAAsB;IACtB,aAAa;IACb,eAAe;IACf,gBAAgB;IAChB,eAAe;AACnB;;AAEA;;;IAGI,+BAA+B;IAC/B,4BAA4B;IAC5B,wBAAwB;AAC5B;;AAEA;;IAEI,aAAa;IACb,kDAAkD;IAClD,SAAS;AACb;;AAEA;;IAEI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,2DAA2D;IAC3D,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,qBAAqB;IACrB,SAAS;IACT,aAAa;IACb,mCAAmC;IACnC,mBAAmB;IACnB,0BAA0B;AAC9B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,UAAU;IACV,+BAA+B;AACnC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,gBAAgB;IAChB,sBAAsB;IACtB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,SAAS;IACT,+BAA+B;AACnC;;AAEA;IACI,aAAa;IACb,SAAO;IACP,sBAAsB;IACtB,QAAQ;IACR,YAAY;AAChB;;AAEA;IACI,uBAAuB;IACvB,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;AAC7B;;AAEA;;IAEI,WAAW;IACX,eAAe;IACf,YAAY;IACZ,SAAS;IACT,eAAe;IACf,mCAAmC;IACnC,mBAAmB;IACnB,4BAA4B;IAC5B,sBAAsB;IACtB,aAAa;IACb,eAAe;AACnB;;AAEA;;;;IAII,oCAAoC;IACpC,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,SAAS;IACT,oBAAoB;AACxB;;AAEA;IACI,mBAAmB;IACnB,+BAA+B;IAC/B,2BAA2B;IAC3B,wBAAwB;IACxB,6BAA6B;AACjC;;AAEA;IACI,6BAA6B;IAC7B,4BAA4B;AAChC;;AAEA;IACI,yBAAyB;IACzB,2BAA2B;IAC3B,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,gCAAgC;IAChC,wBAAwB;IACxB,gBAAgB;AACpB;;AAEA;;IAEI,wBAAwB;AAC5B;;AAEA;IACI,aAAa;IACb,eAAe;IACf,qBAAqB;IACrB,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,gBAAgB;IAChB,UAAU;IACV,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mCAAmC;IACnC,mBAAmB;IACnB,0BAA0B;AAC9B;;AAEA;IACI,aAAa;IACb,eAAe;IACf,QAAQ;IACR,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,mCAAmC;IACnC,mBAAmB;IACnB,4BAA4B;IAC5B,sBAAsB;IACtB,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,QAAQ;IACR,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;IACb,kCAAkC;AACtC;;AAEA;IACI,uBAAuB;IACvB,4BAA4B;IAC5B,cAAc;IACd,aAAa;IACb,mCAAmC;IACnC,mBAAmB;IACnB,2BAA2B;IAC3B,6BAA6B;AACjC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,yBAAyB;IACzB,8BAA8B;IAC9B,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,wBAAwB;IACxB,gCAAgC;AACpC;;AAEA;IACI,sBAAsB;IACtB,8BAA8B;AAClC;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,sBAAsB;IACtB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,oBAAoB;IACpB,0BAA0B;IAC1B,uBAAuB;IACvB,eAAe;IACf,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA;IACI,8BAA8B;IAC9B,sBAAsB;AAC1B;;AAEA;IACI,8BAA8B;IAC9B,sBAAsB;AAC1B;;AAEA;IACI,4BAA4B;IAC5B,wBAAwB;AAC5B;;AAEA;IACI,gCAAgC;IAChC,wBAAwB;AAC5B;;AAEA;IACI,uBAAuB;IACvB,eAAe;IACf,iBAAiB;AACrB;;AAEA;;;IAGI,aAAa;AACjB;;AAEA;IACI,oBAAoB;IACpB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,wBAAwB;IACxB,iBAAiB;IACjB,kBAAkB;IAClB,4BAA4B;AAChC;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,cAAc;IACd,uCAAuC;AAC3C;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;;IAEI,kBAAkB;IAClB,0CAA0C;IAC1C,sBAAsB;IACtB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,MAAM;IACN,0BAA0B;IAC1B,uBAAuB;IACvB,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;AAC7B;;AAEA;IACI,eAAe;AACnB;;AAEA;;IAEI,4BAA4B;AAChC;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,oCAAoC;IACpC,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,uBAAuB;IACvB,SAAS;AACb;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,oBAAoB;IACpB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,QAAQ;IACR,oBAAoB;AACxB;;AAEA;IACI,sBAAsB;IACtB,eAAe;IACf,gBAAgB;AACpB;;AAEA;;IAEI,kBAAkB;IAClB,uBAAuB;IACvB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,sBAAsB;IACtB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,4BAA4B;IAC5B,cAAc;AAClB;;AAEA;;IAEI,SAAS;IACT,oBAAoB;IACpB,sBAAsB;IACtB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,mFAAmF;IACnF,eAAe;IACf,kCAAkC;AACtC;;AAEA;IACI,gBAAgB;IAChB,kCAAkC;AACtC;;AAEA;IACI;QACI,uBAAuB;IAC3B;;IAEA;QACI,eAAe;IACnB;;IAEA;;;;QAII,0BAA0B;QAC1B,sBAAsB;QACtB,oBAAoB;IACxB;;IAEA;;QAEI,WAAW;IACf;;IAEA;QACI,aAAa;QACb,iBAAiB;IACrB;;IAEA;;QAEI,cAAc;IAClB;;IAEA;;QAEI,WAAW;IACf;AACJ;;AAEA;IACI;;QAEI,gBAAgB;IACpB;AACJ","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Be+Vietnam+Pro:wght@300;500;700&family=Geist+Mono:wght@400;500&display=swap\");\n\n.graph-page {\n    --hmi-bg: #F5F8FC;\n    --hmi-card: #FFFFFF;\n    --hmi-accent: #006AFF;\n    --hmi-accent-ink: #FFFFFF;\n    --hmi-text: #0F1926;\n    --hmi-muted: #596980;\n    --hmi-hover: #E8F1FF;\n    --hmi-border: #8F9EB3;\n    --hmi-shadow: 0 1px 2px rgba(15, 23, 42, 0.04), 0 10px 28px rgba(15, 23, 42, 0.05);\n    --hmi-row: #F8FAFC;\n    --hmi-good: #047857;\n    --hmi-good-bg: #ECFDF5;\n    --hmi-warn: #B45309;\n    --hmi-warn-bg: #FFFBEB;\n    --hmi-danger: #B91C1C;\n    --hmi-danger-bg: #FEF2F2;\n    --hmi-input: #FFFFFF;\n    color-scheme: light;\n    box-sizing: border-box;\n    min-height: calc(100vh - 64px);\n    padding: 28px 32px 40px;\n    background: var(--hmi-bg);\n    color: var(--hmi-text);\n    font-family: \"Be Vietnam Pro\", Arial, sans-serif;\n    font-weight: 300;\n}\n\n.graph-page[data-theme=\"dark\"] {\n    --hmi-bg: #0F1926;\n    --hmi-card: #162433;\n    --hmi-accent: #006AFF;\n    --hmi-accent-ink: #FFFFFF;\n    --hmi-text: #FFFFFF;\n    --hmi-muted: #8F9EB3;\n    --hmi-hover: #1C2C42;\n    --hmi-border: #596980;\n    --hmi-shadow: 0 1px 2px rgba(0, 0, 0, 0.28), 0 12px 32px rgba(0, 0, 0, 0.22);\n    --hmi-row: #121A2B;\n    --hmi-good: #34D399;\n    --hmi-good-bg: rgba(52, 211, 153, 0.12);\n    --hmi-warn: #FBBF24;\n    --hmi-warn-bg: rgba(251, 191, 36, 0.12);\n    --hmi-danger: #FCA5A5;\n    --hmi-danger-bg: rgba(248, 113, 113, 0.12);\n    --hmi-input: #0F172A;\n    color-scheme: dark;\n}\n\n.graph-page *,\n.graph-page *::before,\n.graph-page *::after {\n    box-sizing: border-box;\n}\n\n.graph-page h1,\n.graph-page h2,\n.graph-page p {\n    margin: 0;\n    color: var(--hmi-text);\n}\n\n.graph-page__top {\n    margin-bottom: 22px;\n}\n\n.graph-page__eyebrow {\n    margin-bottom: 6px;\n    color: var(--hmi-accent);\n    font-size: 12px;\n    font-weight: 700;\n    letter-spacing: 0.08em;\n    text-transform: uppercase;\n}\n\n.graph-page h1 {\n    font-size: 32px;\n    line-height: 1.15;\n    font-weight: 700;\n    letter-spacing: -0.03em;\n}\n\n.graph-page__subtitle {\n    margin-top: 6px;\n    color: var(--hmi-muted);\n    font-size: 15px;\n}\n\n.graph-page__card {\n    margin-bottom: 18px;\n    border: 1px solid var(--hmi-border);\n    border-radius: 18px;\n    background: var(--hmi-card);\n    box-shadow: var(--hmi-shadow);\n    overflow: hidden;\n}\n\n.graph-page__card-head {\n    padding: 18px 18px 0;\n}\n\n.graph-page__card-head h2 {\n    font-size: 18px;\n    letter-spacing: -0.02em;\n}\n\n.graph-page__card-head p,\n.graph-page__empty {\n    margin-top: 4px;\n    color: var(--hmi-muted);\n    font-size: 13px;\n}\n\n.graph-page__tabs,\n.graph-page__ranges,\n.graph-page__range-grid,\n.graph-page__live-grid,\n.graph-page__selectors,\n.graph-page__actions,\n.graph-page__banner,\n.graph-page__empty,\n.graph-page__plot,\n.graph-page__live-note {\n    margin: 16px 18px;\n}\n\n.graph-page__tabs,\n.graph-page__ranges {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 8px;\n}\n\n.graph-page__tab {\n    min-height: 40px;\n    margin: 0;\n    padding: 8px 16px;\n    border: 1px solid var(--hmi-border);\n    border-radius: 12px 12px 0 0;\n    background: var(--hmi-card);\n    color: var(--hmi-text);\n    font: inherit;\n    font-size: 14px;\n    font-weight: 500;\n    cursor: pointer;\n}\n\n.graph-page__tab[aria-selected=\"true\"] {\n    border-color: var(--hmi-accent);\n    background: var(--hmi-hover);\n    color: var(--hmi-accent);\n}\n\n.graph-page__chip,\n.graph-page__button {\n    min-height: 40px;\n    margin: 0;\n    padding: 8px 14px;\n    border: 1px solid var(--hmi-border);\n    border-radius: 999px;\n    background: var(--hmi-row);\n    color: var(--hmi-text);\n    font: inherit;\n    font-size: 13px;\n    font-weight: 700;\n    cursor: pointer;\n}\n\n.graph-page__chip.is-active,\n.graph-page__chip:hover,\n.graph-page__chip:focus-visible {\n    border-color: var(--hmi-accent);\n    background: var(--hmi-hover);\n    color: var(--hmi-accent);\n}\n\n.graph-page__range-grid,\n.graph-page__live-grid {\n    display: grid;\n    grid-template-columns: repeat(2, minmax(0, 280px));\n    gap: 14px;\n}\n\n.graph-page__appearance,\n.graph-page__selectors {\n    display: grid;\n    gap: 12px;\n}\n\n.graph-page__appearance {\n    grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));\n    align-items: end;\n    margin: 0 18px 18px;\n}\n\n.graph-page__selector {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: flex-end;\n    gap: 12px;\n    padding: 12px;\n    border: 1px solid var(--hmi-border);\n    border-radius: 14px;\n    background: var(--hmi-row);\n}\n\n.graph-page__field--color {\n    flex: 0 0 88px;\n}\n\n.graph-page__field--axis {\n    flex: 0 1 150px;\n}\n\n.graph-page__field input[type=\"color\"] {\n    padding: 4px;\n}\n\n.graph-page__field input[type=\"range\"] {\n    padding: 0;\n    accent-color: var(--hmi-accent);\n}\n\n.graph-page__check {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    min-height: 40px;\n    color: var(--hmi-text);\n    font-size: 14px;\n    font-weight: 700;\n}\n\n.graph-page__check input {\n    width: 18px;\n    height: 18px;\n    margin: 0;\n    accent-color: var(--hmi-accent);\n}\n\n.graph-page__field {\n    display: flex;\n    flex: 1;\n    flex-direction: column;\n    gap: 6px;\n    min-width: 0;\n}\n\n.graph-page__field label {\n    color: var(--hmi-muted);\n    font-size: 11px;\n    font-weight: 700;\n    letter-spacing: 0.05em;\n    text-transform: uppercase;\n}\n\n.graph-page__field input,\n.graph-page__field select {\n    width: 100%;\n    max-width: none;\n    height: 40px;\n    margin: 0;\n    padding: 0 12px;\n    border: 1px solid var(--hmi-border);\n    border-radius: 10px;\n    background: var(--hmi-input);\n    color: var(--hmi-text);\n    font: inherit;\n    font-size: 14px;\n}\n\n.graph-page__field input:focus-visible,\n.graph-page__field select:focus-visible,\n.graph-page__chip:focus-visible,\n.graph-page__button:focus-visible {\n    outline: 2px solid var(--hmi-accent);\n    outline-offset: 2px;\n}\n\n.graph-page__actions {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 10px;\n    padding-bottom: 18px;\n}\n\n.graph-page__button {\n    border-radius: 12px;\n    border-color: var(--hmi-accent);\n    background: var(--hmi-card);\n    color: var(--hmi-accent);\n    box-shadow: var(--hmi-shadow);\n}\n\n.graph-page__button--primary {\n    background: var(--hmi-accent);\n    color: var(--hmi-accent-ink);\n}\n\n.graph-page__button--export {\n    border-color: transparent;\n    background: var(--hmi-good);\n    color: #FFFFFF;\n}\n\n.graph-page[data-theme=\"dark\"] .graph-page__button--export {\n    color: #052E1C;\n}\n\n.graph-page__button--danger {\n    border-color: transparent;\n    background: var(--hmi-danger-bg);\n    color: var(--hmi-danger);\n    box-shadow: none;\n}\n\n.graph-page__button:hover,\n.graph-page__button:focus-visible {\n    filter: brightness(0.97);\n}\n\n.graph-page__preset-bar {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: flex-end;\n    gap: 10px;\n    margin: 16px 18px 0;\n}\n\n.graph-page__preset-bar .graph-page__field {\n    flex: 1 1 240px;\n}\n\n.graph-page__preset-list {\n    display: grid;\n    gap: 12px;\n    margin: 14px 0 0;\n    padding: 0;\n    list-style: none;\n}\n\n.graph-page__preset-item {\n    padding: 12px;\n    border: 1px solid var(--hmi-border);\n    border-radius: 14px;\n    background: var(--hmi-row);\n}\n\n.graph-page__preset-rename {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 8px;\n    align-items: center;\n}\n\n.graph-page__preset-rename input {\n    flex: 1 1 180px;\n    height: 40px;\n    min-width: 0;\n    padding: 0 12px;\n    border: 1px solid var(--hmi-border);\n    border-radius: 10px;\n    background: var(--hmi-input);\n    color: var(--hmi-text);\n    font: inherit;\n}\n\n.graph-page__preset-tags {\n    margin: 10px 0 0;\n    padding-left: 18px;\n    color: var(--hmi-muted);\n    font-size: 13px;\n}\n\n.graph-page__dialog-backdrop {\n    position: fixed;\n    inset: 0;\n    z-index: 30;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 24px;\n    background: rgba(15, 25, 38, 0.45);\n}\n\n.graph-page__dialog {\n    width: min(480px, 100%);\n    max-height: min(80vh, 720px);\n    overflow: auto;\n    padding: 18px;\n    border: 1px solid var(--hmi-border);\n    border-radius: 18px;\n    background: var(--hmi-card);\n    box-shadow: var(--hmi-shadow);\n}\n\n.graph-page__dialog--wide {\n    width: min(680px, 100%);\n}\n\n.graph-page__dialog h3 {\n    margin: 0 0 8px;\n    font-size: 18px;\n}\n\n.graph-page__dialog p {\n    color: var(--hmi-muted);\n}\n\n.graph-page__banner.is-good {\n    border-color: transparent;\n    background: var(--hmi-good-bg);\n    color: var(--hmi-good);\n}\n\n.graph-page__button:disabled {\n    opacity: 0.55;\n    cursor: not-allowed;\n}\n\n.graph-page__banner {\n    padding: 12px 14px;\n    border-radius: 12px;\n    font-size: 14px;\n    font-weight: 600;\n}\n\n.graph-page__banner.is-error {\n    color: var(--hmi-danger);\n    background: var(--hmi-danger-bg);\n}\n\n.graph-page__banner.is-warn {\n    color: var(--hmi-warn);\n    background: var(--hmi-warn-bg);\n}\n\n.graph-page__status {\n    display: inline-flex;\n    align-items: center;\n    align-self: flex-start;\n    min-height: 28px;\n    margin-top: 2px;\n    padding: 4px 10px;\n    border-radius: 999px;\n    background: var(--hmi-row);\n    color: var(--hmi-muted);\n    font-size: 12px;\n    font-weight: 700;\n    letter-spacing: 0.04em;\n}\n\n.graph-page__status.is-live {\n    background: var(--hmi-good-bg);\n    color: var(--hmi-good);\n}\n\n.graph-page__status.is-paused {\n    background: var(--hmi-warn-bg);\n    color: var(--hmi-warn);\n}\n\n.graph-page__status.is-loading {\n    background: var(--hmi-hover);\n    color: var(--hmi-accent);\n}\n\n.graph-page__status.is-error {\n    background: var(--hmi-danger-bg);\n    color: var(--hmi-danger);\n}\n\n.graph-page__live-note {\n    color: var(--hmi-muted);\n    font-size: 13px;\n    line-height: 1.45;\n}\n\n.graph-page__live-note + .graph-page__live-note,\n.graph-page__live-note + .graph-page__banner,\n.graph-page__banner + .graph-page__banner {\n    margin-top: 0;\n}\n\n.graph-page__empty {\n    padding-bottom: 18px;\n    text-align: center;\n    font-size: 14px;\n}\n\n.graph-page__plot {\n    height: min(520px, 62vh);\n    min-height: 320px;\n    padding: 8px 8px 0;\n    overscroll-behavior: contain;\n}\n\n.graph-page__plot canvas {\n    max-width: 100%;\n}\n\n.graph-page__table-wrap {\n    max-height: 360px;\n    margin-top: 8px;\n    overflow: auto;\n    border-top: 1px solid var(--hmi-border);\n}\n\n.graph-page__table {\n    width: 100%;\n    min-width: 480px;\n    border-collapse: collapse;\n}\n\n.graph-page__table th,\n.graph-page__table td {\n    padding: 12px 16px;\n    border-bottom: 1px solid var(--hmi-border);\n    color: var(--hmi-text);\n    text-align: left;\n    font-size: 14px;\n}\n\n.graph-page__table th {\n    position: sticky;\n    top: 0;\n    background: var(--hmi-row);\n    color: var(--hmi-muted);\n    font-size: 11px;\n    font-weight: 700;\n    letter-spacing: 0.05em;\n    text-transform: uppercase;\n}\n\n.graph-page__table tbody tr {\n    cursor: pointer;\n}\n\n.graph-page__table tbody tr:hover td,\n.graph-page__table tbody tr.is-selected td {\n    background: var(--hmi-hover);\n}\n\n.graph-page__table tbody tr.is-selected td {\n    color: var(--hmi-accent);\n}\n\n.graph-page__table tbody tr:focus-visible td {\n    outline: 2px solid var(--hmi-accent);\n    outline-offset: -2px;\n}\n\n.graph-page__card-head--split {\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-start;\n    gap: 12px;\n}\n\n.graph-page__swatch {\n    width: 14px;\n    height: 14px;\n    margin-top: 6px;\n    border-radius: 999px;\n    flex: 0 0 auto;\n}\n\n.graph-page__zoom {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    gap: 8px;\n    padding: 12px 18px 0;\n}\n\n.graph-page__zoom-state {\n    color: var(--hmi-warn);\n    font-size: 13px;\n    font-weight: 700;\n}\n\n.graph-page__hint,\n.graph-page__selection {\n    margin: 8px 18px 0;\n    color: var(--hmi-muted);\n    font-size: 13px;\n    line-height: 1.45;\n}\n\n.graph-page__selection {\n    color: var(--hmi-text);\n    font-size: 14px;\n    font-weight: 650;\n}\n\n.graph-page__records-bar {\n    display: flex;\n    justify-content: flex-end;\n    margin: 4px 0 12px;\n}\n\n.graph-page__records-body {\n    max-height: min(520px, 58vh);\n    overflow: auto;\n}\n\n.graph-page__record-group h3,\n.graph-page__record-title {\n    margin: 0;\n    padding: 14px 16px 0;\n    color: var(--hmi-text);\n    font-size: 15px;\n}\n\n.graph-page__record-title {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n}\n\n.graph-page__record-title .graph-page__swatch {\n    margin-top: 0;\n}\n\n.graph-page__record-group + .graph-page__record-group {\n    border-top: 1px solid var(--hmi-border);\n}\n\n.graph-page__mono {\n    font-family: \"Geist Mono\", ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;\n    font-size: 13px;\n    font-variant-numeric: tabular-nums;\n}\n\n.graph-page__value {\n    font-weight: 700;\n    font-variant-numeric: tabular-nums;\n}\n\n@media (max-width: 800px) {\n    .graph-page {\n        padding: 18px 14px 28px;\n    }\n\n    .graph-page h1 {\n        font-size: 26px;\n    }\n\n    .graph-page__range-grid,\n    .graph-page__live-grid,\n    .graph-page__selector,\n    .graph-page__actions {\n        grid-template-columns: 1fr;\n        flex-direction: column;\n        align-items: stretch;\n    }\n\n    .graph-page__button,\n    .graph-page__chip {\n        width: 100%;\n    }\n\n    .graph-page__plot {\n        height: 300px;\n        min-height: 240px;\n    }\n\n    .graph-page__field--color,\n    .graph-page__field--axis {\n        flex: 1 1 auto;\n    }\n\n    .graph-page__zoom .graph-page__button,\n    .graph-page__records-bar .graph-page__button {\n        width: auto;\n    }\n}\n\n@media (prefers-reduced-motion: reduce) {\n    .graph-page__button,\n    .graph-page__chip {\n        transition: none;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
